module.exports = __webpack_public_path__ + "static/media/gam.bd16cc59.svg";